import type { IconNode } from '../types';

/**
 * @name wine-glass-bottle
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyAxM2g4IiAvPgogIDxwYXRoIGQ9Ik01IDdzLTIgMy0yIDZhNCA0IDAgMCAwIDggMGMwLTMtMi02LTItNloiIC8+CiAgPHBhdGggZD0iTTcgMTd2NSIgLz4KICA8cGF0aCBkPSJNNCAyMmg2IiAvPgogIDxwYXRoIGQ9Ik0xOCA0YzAgMy0zIDMtMyA2djExYzAgLjYuNCAxIDEgMWg0Yy42IDAgMS0uNCAxLTFWMTBjMC0zLTMtMy0zLTYiIC8+CiAgPHBhdGggZD0iTTE4IDRWMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/wine-glass-bottle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const wineGlassBottle: IconNode = [
  ['path', { d: 'M3 13h8', key: '14j198' }],
  ['path', { d: 'M5 7s-2 3-2 6a4 4 0 0 0 8 0c0-3-2-6-2-6Z', key: '1yn5kj' }],
  ['path', { d: 'M7 17v5', key: '1yj1jh' }],
  ['path', { d: 'M4 22h6', key: '1b5wmr' }],
  [
    'path',
    { d: 'M18 4c0 3-3 3-3 6v11c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V10c0-3-3-3-3-6', key: '11v778' },
  ],
  ['path', { d: 'M18 4V2', key: '1jsdo1' }],
];

export default wineGlassBottle;
